import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ChartDataLabels from "chartjs-plugin-datalabels";
// Hooks
// actions creators
import {
  getData,
  changeCompanies,
  getProfits,
} from "redux/ducks/profitStation";

// views
import CardSelect from "components/CardSelect/CardSelect";
import CardGraph from "components/CardGraph/CardGraph";
import { setSnackbar } from "redux/actions/search/searchActions";
import {
  GraphContainerLeft,
  GraphContainerRight,
  GraphsWrapper,
} from "./styles";
import "./styles.css";

const options = {
  maintainAspectRatio: false,
  scales: {
    x: {
      offset: true,
    },
  },
  plugins: {
    datalabels: {
      color: "black",
      align: "end",
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

export default function ProfitStation() {
  const dispatch = useDispatch();

  // selectors

  const graphs = useSelector((state) => state.profitStation.graphs);
  const companies = useSelector((state) => state.profitStation.companies);
  const isLoading = useSelector((state) => state.profitStation.isLoading);
  const companiesSelected = useSelector(
    (state) => state.profitStation.companiesSelected
  );

  const handleChangeCompaniesCall = useCallback(
    (companies) => {
      dispatch(changeCompanies(companies));
    },
    []
  );

  const handleSubmit = useCallback(() => {
    if (!companiesSelected?.length) {
      dispatch(setSnackbar("No se ha seleccionado alguna empresa.", "danger"));
      return;
    }
    dispatch(getProfits(companiesSelected));
  }, [companiesSelected]);

  // Effects
  useEffect(() => {
    dispatch(getData());
  }, []);

  return (
    <>
      <CardSelect
        title="Empresas"
        placeholder="Empresas..."
        name="companies"
        data={companies}
        value={companiesSelected}
        onChange={handleChangeCompaniesCall}
        onSubmit={handleSubmit}
        disabled={isLoading}
      />
      {graphs
        ? graphs.map((graph, index) => (
          <React.Fragment key={`companie-${index}`}>
            <CardGraph
              isVertical
              title={`Promedio ${graph.name}`}
              height={400}
              data={{ datasets: graph.datasets, labels: graph.labels }}
              options={options}
              plugins={[ChartDataLabels]}
            />
            {graph.stations.map((station) => (
              <GraphsWrapper key={`${station.name}-${index}`}>
                <GraphContainerRight>
                  <CardGraph
                    isVertical
                    height={300}
                    title={`Historico de Margen ${station.name}`}
                    data={station.history}
                    plugins={[ChartDataLabels]}
                    options={options}
                  />
                </GraphContainerRight>
                <GraphContainerLeft>
                  <CardGraph
                    isVertical
                    title={`Margen Planta ${station.name}`}
                    height={300}
                    data={station.profit}
                    plugins={[ChartDataLabels]}
                    options={options}
                  />
                </GraphContainerLeft>
              </GraphsWrapper>
            ))}
          </React.Fragment>
          ))
        : null}
    </>
  );
}
